//@flow
import React, { useState } from 'react';
import classNames from 'classnames';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { HTMLView } from 'components/atoms/htmlView';
import { ActionButton } from 'components/atoms/button';
import { Image } from 'components/atoms/image';
import IconCoralRight from 'assets/images/RIGHT.png';
import playButton from 'assets/images/Play-Button-S.png';
import { OverlayPortal } from 'components/templates/overlayPortal';
import { OverlayModal } from 'components/templates/overlayModal';
import { useViewport } from 'components/templates/viewportProvider';
import Marker from 'assets/images/marker.png';
//eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  heading: string,
  subHeading: string,
  content: string,
  imageData?: string,
  videoData?: string,
  buttonName?: string,
  isComponentLoaded?: boolean,
  thumbNailUrl?: string,
  videoThumbnailUrl?: string,
  onClick?: void,
};

const VideoInfoModule = (props: Props) => {
  const {
    onClick,
    containerClassName,
    heading,
    subHeading,
    content,
    buttonName,
    thumbNailUrl,
    videoData,
    imageData,
    tagWord,
    videoThumbnailUrl,
  } = props;

  const { height } = useViewport();
  const [showVideoLayout, setshowVideoLayout] = useState(false);

  const containerClassNames = classNames(
    'video-info-module',
    containerClassName
  );

  const showOverlay = showVideoLayout ? (
    <OverlayPortal>
      <OverlayModal
        data={videoData.__html}
        theme={'dark-theme'}
        type={'video-overlay'}
        className={'testimonialVideoOverlay'}
        onClosePress={() => setshowVideoLayout(false)}
        breadcrumbList={[]}
      />
    </OverlayPortal>
  ) : null;

  return (
    <div className={containerClassNames} style={{ height }}>
      <div className="video-module-inner-section">
        <div className="page-text">
          <Row>
            <Col md={{ span: 2 }}>
              <h1 className={'title'}>{heading}</h1>
            </Col>
            <Col md={{ span: 3, offset: 2 }}>
              <HTMLView
                tagName={'div'}
                className={'sub-heading'}
                html={subHeading}
              />
              {tagWord && <h6>{tagWord}</h6>}
            </Col>
            <Col md={{ span: 3, offset: 1 }}>
              <HTMLView tagName={'p'} className={'paragraph'} html={content} />
              {buttonName && (
                <Col md={{ span: 10 }}>
                  <ActionButton
                    className="explore-module"
                    onClick={onClick}
                    buttonName={buttonName}
                    iconRight={IconCoralRight}
                  />
                </Col>
              )}
            </Col>
          </Row>
        </div>
        <div className="media-section">
          <Row style={{ height: '100%' }}>
            <Col style={{ height: '100%' }} md={{ span: 12 }}>
              {videoData && videoData.__html && (
                <>
                  <img src={videoThumbnailUrl} alt="video" />
                  <img
                    className={'play-icon'}
                    src={playButton}
                    alt={'play-icon'}
                    onClick={() => setshowVideoLayout(true)}
                  />
                </>
              )}
              {imageData && (
                <Image thumbNail={thumbNailUrl} src={imageData} alt={'media'} />
              )}
            </Col>
          </Row>
          {showOverlay}
        </div>
      </div>
    </div>
  );
};

export default VideoInfoModule;
